import ISO6391 from 'iso-639-1';

export interface SupportedLanguage {
  code: string;
  label: string;
  flag: string;
  /** BCP-47 accept-language header value */
  acceptLanguage: string;
}

const SUPPORTED_CODES = ['en', 'es'];

const FLAG_MAP: Record<string, string> = {
  en: '🇺🇸',
  es: '🇪🇸',
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = SUPPORTED_CODES.map((code) => {
  const native = ISO6391.getNativeName(code);
  const label = native ? native.charAt(0).toUpperCase() + native.slice(1) : code.toUpperCase();
  return {
    code,
    label,
    flag: FLAG_MAP[code] || '🌐',
    acceptLanguage: code === 'en' ? 'en-US,en;q=0.9' : code,
  };
});

export const DEFAULT_LANGUAGE_CODE = 'es';
